import React from "react"

export default function Forward() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M9.99392 3.21992C9.59667 2.77844 8.90446 2.77844 8.5072 3.21992L4.37813 7.80868C3.91486 8.32352 4.28023 9.1438 4.97281 9.1438H6.6475V12.5188H11.8536V9.1438H13.5283C14.2209 9.1438 14.5863 8.32352 14.123 7.80869L9.99392 3.21992Z" fill="#5B5E71" />
         <path d="M6.55103 14.2063H11.95V14.8938C11.95 15.4461 11.5022 15.8938 10.95 15.8938H7.55102C6.99874 15.8938 6.55103 15.4461 6.55103 14.8938V14.2063Z" fill="#5B5E71" />
      </svg>
   )
}
